import { IndexDBProduct } from "../db/db";

export const toNumber = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;
  const numericValue = typeof value === 'string' ? Number(value) : Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const getSaleItemRate = (item: any, dbProduct?: IndexDBProduct) => {
  const candidates = [
    item?.w_rate,
    item?.r_rate,
    item?.rate,
    item?.selling_rate,
    item?.sale_rate,
    dbProduct?.retailRate,
    dbProduct?.wholesaleRate,
    dbProduct?.mrp,
  ];

  for (const candidate of candidates) {
    const numericValue = toNumber(candidate);
    if (numericValue !== 0) {
      return numericValue;
    }
  }

  return 0;
};

export const getSaleItemMrp = (item: any, stockObj?: any) => {
  const candidates = [item?.mrp, stockObj?.mrp, stockObj?.priceGst];

  for (const candidate of candidates) {
    const numericValue = toNumber(candidate);
    if (numericValue !== 0) {
      return numericValue;
    }
  }

  return 0;
};
